/* eslint-disable max-lines */
import { Button } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import ProductQuickView from 'components/Shared/ProductQuickView';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { IConfig } from 'interfaces/config';
import { IProductNew } from 'interfaces/product';
import React, { Component } from 'react';
import * as rxjsOperators from 'rxjs-operators';
import { configService } from 'services/configService';
import { productNewService } from 'services/productNewService';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Snackbar from 'components/Shared/Snackbar';
import PopUp from 'components/Shared/PopUp';
import { Chip } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import { combineLatest } from 'rxjs';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';

interface IState {
  selectedProduct: IProductNew;
  config: IConfig;
  show: boolean;
}

interface IProps {
  classes?: any;
}

@WithStyles(theme => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(448px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  snackbar: {
    marginBottom: 16,
    maxWidth: 'none',
    boxShadow: 'none',
    backgroundColor: '#ffa000',
    padding: '0 0 0 18px',
    color: '#FFF',
    fontWeight: 500
  },
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  infoIcon: {
    marginRight: 15,
    fill: '#FFF'
  },
  drawerPaper: {
    transform: 'translate(448px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    width: '448px',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  },
  drawerOptions: {
    overflow: 'scroll',
    backgroundColor: '#fff',
    height: '100%',
    padding: 20,
    width: '100%',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10
    }
  },
  titleClose: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  h2: {
    fontWeight: 'bold',
    color: theme.variables.colors['primaryColor'],
    margin: 0
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: '0px solid #000',
    borderRadius: '100%',
    width: 40,
    height: 40,
    color: '#596375',
    fontWeight: 'bold',
    backgroundColor: '#D8D8D8',
    cursor: 'pointer',
    alignSelf: 'flex-start',
    '&:hover': {
      backgroundColor: '#ccc'
    },
    '& svg': {
      width: '30%',
      fontWeight: 'bold',
      fill: '#596375'
    }
  },

  titleScript: {
    fontWeight: 'bold'
  },
  buttonContinue: {
    marginTop: 50,
    width: '100%',
    textAlign: 'start'
  },
  link: {
    color: '#FFF'
  },
  button: {
    fontWeight: 400,
    backgroundColor: '#009358',
    color: '#fff',
    width: '100%',
    padding: 10,
    marginBottom: 10
  },
  span: {
    fontSize: '1rem',
    color: '#596375',
    fontWeight: 'bold'
  },
  containerHasThankyou: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  divider: {
    margin: '12px 0'
  },
  chipActive: {
    color: '#009358',
    borderColor: '#009358',
    width: 120,
    fontSize: ' 0.7rem'
  },
  chipInactive: {
    color: '#8E8E8E',
    width: 120,
    bordderColor: '#8E8E8E',
    fontSize: ' 0.7rem'
  }
}))
export default class ConfigActions extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { selectedProduct: null, config: null, show: false };
  }

  componentDidMount() {
    combineLatest([configService.getSelectedProduct(), configService.getProductConfig()])
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(([selectedProduct, config]) => {
        this.setState({ selectedProduct, config });
      });

    configService
      .getVisibility()
      .pipe(rxjsOperators.map(drawer => drawer === 'upSell'))
      .subscribe(show => this.setState({ show }));

    combineLatest([configService.getSelectedProduct(), configService.getProductConfig(), configService.getVisibility()])
      .pipe(
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(([selectedProduct, config, drawer]) => {
          return { selectedProduct, config: !!config, drawer };
        }),
        rxjsOperators.distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        rxjsOperators.filter(
          ({ selectedProduct, config, drawer }) => !!selectedProduct && !!config && drawer === 'upSell'
        )
      )
      .subscribe(() => {
        analyticsG4.sendPageView({ feature: enFeatures.OBRIGADO_UPSELL });
      });
  }

  switchHasThankYouUpsell = () => {
    const { config } = this.state;

    this.setState({ config: { ...config, hasThankyouUpsell: !config.hasThankyouUpsell } });
  };

  onClose = () => {
    configService.hideDrawer();
  };

  saveConfig = () => {
    const { selectedProduct, config } = this.state;
    configService
      .saveConfig(config)
      .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
      .subscribe(() => {
        Snackbar.show('Configuração salva!');
        analyticsG4.sendSuccess(enFeatures.OBRIGADO_UPSELL);

        productNewService.setSelectedProduct({
          ...selectedProduct,
          config: { ...selectedProduct.config, hasThankyouUpsell: true }
        });
        productNewService.refreshProducts();
      });

    this.onClose();
  };

  render(): JSX.Element {
    const { classes } = this.props;
    const { selectedProduct, config, show } = this.state;

    if (!show) {
      return null;
    }

    const hasThankYouCreditcard = !!selectedProduct.hasThankYouUrl;
    const hasThankYouBankslip = !!selectedProduct.hasThankYouUrlBankslip;
    const hasHttpsThankYouCreditcard = selectedProduct?.hasThankYouUrl?.includes('https');
    const hasHttpsThankYouBankslip = selectedProduct?.hasThankYouUrlBankslip?.includes('https');
    const redirectOrbita = `https://orbita.eduzz.com/producer/product/editproduct/${selectedProduct.id}`;
    return (
      <Drawer
        anchor="right"
        open={!!selectedProduct}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
        PaperProps={{ classes: { root: classes.drawerPaper } }}
      >
        <div className={classes.drawerOptions}>
          <div className={classes.titleClose}>
            <h2 className={classes.h2}>Página de obrigado para Upsell</h2>
            <span className={classes.closeButton} onClick={this.onClose}>
              <SvgIcon name={'closeIcon'} />
            </span>
          </div>
          <ProductQuickView />
          <div className={classes.containerHasThankyou}>
            <span className={classes.span}>Página de Obrigado para Boleto</span>
            <Chip
              className={hasThankYouBankslip ? classes.chipActive : classes.chipInactive}
              label={hasThankYouBankslip ? 'Habilitado' : 'Desabilitado'}
              variant="outlined"
            />
          </div>
          <Divider className={classes.divider} />
          <div style={{ marginBottom: 10 }} className={classes.containerHasThankyou}>
            <span className={classes.span}>Página de Obrigado para Cartão</span>
            <Chip
              className={hasThankYouCreditcard ? classes.chipActive : classes.chipInactive}
              label={hasThankYouCreditcard ? 'Habilitado' : 'Desabilitado'}
              variant="outlined"
            />
          </div>

          {hasThankYouBankslip && !hasHttpsThankYouBankslip && (
            <PopUp type="info" message={<p>Verifique se sua página de obrigado para boleto possui https</p>} />
          )}

          {hasThankYouCreditcard && !hasHttpsThankYouCreditcard && (
            <PopUp type="info" message={<p>Verifique se sua página de obrigado para cartão possui https</p>} />
          )}

          {!hasThankYouBankslip && (
            <PopUp
              type="info"
              message={
                <p>
                  Você não possui página de obrigado para boleto cadastrada,{' '}
                  <a target="_blank" rel="noopener noreferrer" href={redirectOrbita}>
                    Clique aqui
                  </a>{' '}
                  e entre na aba avançado para cadastrar{' '}
                </p>
              }
            />
          )}

          {!hasThankYouCreditcard && (
            <PopUp
              type="info"
              message={
                <p>
                  Você não possui página de obrigado para cartão cadastrada,{' '}
                  <a target="_blank" rel="noopener noreferrer" href={redirectOrbita}>
                    Clique aqui
                  </a>{' '}
                  e entre na aba avançado para cadastrar{' '}
                </p>
              }
            />
          )}
          <div className={classes.contentScripts}>
            <FormControlLabel
              classes={{ label: classes.fontName }}
              control={
                <Switch
                  disableRipple
                  disabled={!hasThankYouCreditcard && !hasThankYouBankslip}
                  checked={config.hasThankyouUpsell}
                  onChange={this.switchHasThankYouUpsell}
                  value={'config.hasThankyouUpsell'}
                />
              }
              label="Ativar página de obrigado para upsell"
            />
          </div>
          <Button
            disabled={!hasThankYouCreditcard && !hasThankYouBankslip}
            onClick={this.saveConfig}
            className={classes.button}
          >
            Salvar
          </Button>
        </div>
      </Drawer>
    );
  }
}
